/**
 * @ngdoc directive
 * @name directiveErrorComment
 * @restrict A
 *
 * @description
 * Directive for myRatings error comment
 *
 * @element ANY
 */

export default function () {
    return {
        restrict: 'E',
        template: `<div class="rp-myRatings__errorComment js-runnerRowErrorComment">
                        There's a technical problem that means notes and ratings content is 
                        currently unavailable. We are working to restore the service as fast
                         as possible and are sorry for any inconvenience caused. Please click
                        <span class="rp-myRatings__errorComment__link"
                              data-ng-click="getUgcData()">here</span>
                            to refresh the page or try again later.
                    </div>`
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/errorComment.js